import { Badge, Card, Col, Row } from 'react-bootstrap';

const statusVariantMap = {
    PENDING: 'warning',
    REQUESTED: 'warning',
    CONFIRMED: 'success',
    COMPLETED: 'primary',
    INVOICED: 'dark',
    CANCELLED: 'danger',
};

function formatDate(value) {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString();
}

function formatMoney(cents, currency = 'EUR') {
    const value = Number(cents || 0) / 100;
    try {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
        }).format(value);
    } catch {
        return `${value.toFixed(2)} ${currency}`;
    }
}

const SupplierBookingSummary = ({ booking }) => {
    const extras = Array.isArray(booking?.extras) ? booking.extras : [];

    return (
        <>
            <Card className="shadow-sm border-0 mb-4">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                        <div>
                            <div className="text-muted small mb-1">Reference Number</div>
                            <h4 className="mb-2">{booking.referenceNumber}</h4>
                            <Badge bg={statusVariantMap[booking.status] || 'secondary'}>
                                {booking.status}
                            </Badge>
                        </div>

                        <div className="text-end">
                            <div className="fw-semibold">
                                {booking.motorcycleBrand} {booking.motorcycleName}
                            </div>
                            <div className="text-muted">
                                {booking.motorcycleYear} · {booking.motorcycleType}
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-white fw-semibold">Rental Summary</Card.Header>
                <Card.Body>
                    <Row className="g-3">
                        <Col md={6}>
                            <div className="text-muted small">Pickup</div>
                            <div>{formatDate(booking.startDate)} {booking.startTime || ''}</div>
                        </Col>
                        <Col md={6}>
                            <div className="text-muted small">Return</div>
                            <div>{formatDate(booking.endDate)} {booking.endTime || ''}</div>
                        </Col>

                        <Col md={6}>
                            <div className="text-muted small">Shop</div>
                            <div>{booking.shopName}</div>
                        </Col>
                        <Col md={6}>
                            <div className="text-muted small">Address</div>
                            <div>{booking.shopAddress}</div>
                        </Col>

                        <Col md={6}>
                            <div className="text-muted small">Pickup Location</div>
                            <div>{booking.pickupLocation}</div>
                        </Col>
                        <Col md={6}>
                            <div className="text-muted small">City / Country</div>
                            <div>{booking.pickupCity} / {booking.pickupCountry}</div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="shadow-sm border-0 mb-4">
                <Card.Header className="bg-white fw-semibold">Vehicle & Extras</Card.Header>
                <Card.Body>
                    <Row className="g-4">
                        <Col md={6}>
                            <div className="text-muted small mb-1">Motorcycle</div>
                            <div className="fw-semibold">
                                {booking.motorcycleBrand} {booking.motorcycleName}
                            </div>
                            <div className="text-muted">
                                {booking.motorcycleYear} · {booking.motorcycleType}
                            </div>

                            {booking.motorcyclePhoto ? (
                                <img
                                    src={booking.motorcyclePhoto}
                                    alt={booking.motorcycleName}
                                    className="img-fluid rounded mt-3"
                                    style={{ maxHeight: 180, objectFit: 'cover' }}
                                />
                            ) : null}
                        </Col>

                        <Col md={6}>
                            <div className="text-muted small mb-2">Extras</div>

                            {extras.length > 0 ? (
                                <div className="ps-1">
                                    {extras.map((item, index) => (
                                        <div
                                            key={item?.id || index}
                                            className="d-flex justify-content-between align-items-center mb-1"
                                        >
                                            <div>
                                                {item?.name || item?.meta?.name || 'Extra item'}
                                            </div>

                                            <div className="text-muted small">
                                                x{item?.quantity ?? 1}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-muted">No extras selected</div>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </>
    );
};

export default SupplierBookingSummary;